import { ClientVideoAnalysisService } from '@src/services/upload/videoAnalysis/ClientVideoAnalysisService';
import { useStore } from '@src/stores-v2/StoreContext';
import { useMemo } from 'react';

export function useClientVideoAnalysisService(): ClientVideoAnalysisService {
  const { userIdentityStore } = useStore();
  const apiUrl = process.env.REACT_APP_API_URL || '';
  return useMemo(
    () =>
      new ClientVideoAnalysisService(
        apiUrl,
        async () => (await userIdentityStore.getFreshToken()) || undefined,
      ),
    [apiUrl, userIdentityStore],
  );
}
